import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Layout = ({children, hideActions = false}) => {
  return (
    <div className="min-h-screen bg-black text-white font-sans selection:bg-red-600 selection:text-white">
      <nav className="border-b border-zinc-800 bg-zinc-950/50 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="group flex flex-col justify-center">
            <div className="flex items-center gap-2">
              <img 
                src="https://i.postimg.cc/28pHNw0g/Add-a-heading-3-removebg-preview-(1).png" 
                alt="ConnectKard" 
                className="w-8 h-8 object-contain transform group-hover:scale-110 transition-transform duration-300" 
              />
              <span className="font-bold text-lg tracking-tight leading-none">
                Connect<span className="text-red-500">Kard</span>
              </span>
            </div>
            <p className="text-[8px] font-bold tracking-wider mt-0.5 ml-10 leading-none whitespace-nowrap">
              <span className="text-red-500">One QR</span> <span className="text-white">...</span> <span className="text-white">Infinite Connections</span> <span className="text-red-500">...</span>
            </p>
          </Link>
          {!hideActions && (
            <div className="flex gap-4 text-sm font-medium text-zinc-400">
              <Link to="/editqr" className="hover:text-red-500 transition-colors">
                Edit Card
              </Link>
            </div>
          )}
        </div>
      </nav>
      <main className="max-w-md mx-auto px-4 py-8 relative">
        {/* Background Ambient Glow */}
        <div className="fixed top-20 left-1/2 -translate-x-1/2 w-64 h-64 bg-red-600/10 rounded-full blur-3xl -z-10 pointer-events-none" />
        {children}
      </main>
    </div>
  );
};

export default Layout;